export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphByUser: "https://graph.microsoft.com/v1.0/users/"

};